<template>
  <div class="hero-items-wrapper--desktop-shadow d-none d-sm-block">
    <div class="hero-items-wrapper--desktop">
      <img
        loading="lazy"
        width="40px"
        class="hero-image--top-blue-circle"
        src="/img/hero/spotify.png"
      />
      <img
        loading="lazy"
        class="hero-image--bottom-blue-circle"
        src="/img/hero/blue-circle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--blue-cross"
        src="/img/hero/blue-cross.svg"
      />
      <img
        loading="lazy"
        class="hero-image--blue-diamond"
        src="/img/hero/blue-diamond.svg"
      />
      <img
        loading="lazy"
        class="hero-image--green-rectangle"
        src="/img/hero/green-rectangle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--blue-square"
        src="/img/hero/blue-square.svg"
      />
      <img
        loading="lazy"
        class="hero-image--blue-vertical-rectangle"
        src="/img/hero/blue-vertical-rectangle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--green-diagonal-squares"
        src="/img/hero/diagonal-squares.svg"
      />
      <img
        loading="lazy"
        class="hero-image--green-half-oval"
        src="/img/hero/green-half-oval.svg"
      />
      <img
        loading="lazy"
        class="hero-image--green-pointer"
        src="/img/hero/green-pointer.svg"
      />
      <img
        loading="lazy"
        class="hero-image--green-square"
        src="/img/hero/green-square.svg"
      />
      <img
        loading="lazy"
        class="hero-image--green-circle"
        src="/img/hero/green-circle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--light-blue-circle"
        src="/img/hero/light-blue-circle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--orange-curve"
        src="/img/hero/github.png"
      />
      <img
        loading="lazy"
        class="hero-image--red-chatbox"
        src="/img/hero/red-chatbox.svg"
      />
      <img
        loading="lazy"
        class="hero-image--red-diamond"
        src="/img/hero/red-diamond.svg"
      />
      <img
        loading="lazy"
        class="hero-image--red-hand"
        src="/img/hero/red-hand.svg"
      />
      <img
        loading="lazy"
        class="hero-image--left-red-rectangle"
        src="/img/hero/logo_photos_192px.svg"
      />
      <img
        loading="lazy"
        class="hero-image--right-red-rectangle"
        src="/img/hero/yt.png"
      />
      <img
        loading="lazy"
        class="hero-image--red-square"
        src="/img/hero/red-square.svg"
      />
      <img
        loading="lazy"
        class="hero-image--light-red-rectangle"
        src="/img/hero/light-red-rectangle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--light-red-square"
        src="/img/hero/light-red-square.svg"
      />
      <img
        loading="lazy"
        class="hero-image--red-triangle"
        src="/img/hero/red-triangle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--yellow-nested-rectangle"
        src="/img/hero/yellow-nested-rectangle.svg"
      />
      <img
        loading="lazy"
        width="30px"
        class="hero-image--yellow-play-button"
        src="/img/hero/discord.svg"
      />
      <img
        loading="lazy"
        width="35px"
        class="hero-image--yellow-pointer"
        src="/img/hero/xd.svg"
      />
      <img
        loading="lazy"
        class="hero-image--yellow-rectangle"
        src="/img/hero/yellow-rectangle.svg"
      />
      <img
        loading="lazy"
        class="hero-image--yellow-vertical-rectangle"
        src="/img/hero/yellow-vertical-rectangle.svg"
      />
      <img
        loading="lazy"
        width="40px!important"
        class="hero-image--yellow-semi-circle"
        src="/img/hero/elrond.svg"
      />
      <img
        loading="lazy"
        class="hero-image--yellow-sphere"
        src="/img/hero/yellow-sphere.svg"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hero'
}
</script>

<style>
.js-loading *,
.js-loading :after,
.js-loading :before {
  animation-play-state: paused !important;
}
[_nghost-c3] {
  margin: 0;
  display: -ms-flexbox;
  display: flex;
}
.page-constraint {
  -ms-flex-align: center;
  align-items: center;
  width: 100vw;
  max-width: 100vw;
  height: 90vh;
  position: relative;
  padding: 0;
  overflow: hidden;
  margin: 0;
}
@media screen and (max-width: 750px) {
  .page-constraint {
    -ms-flex-direction: column;
    flex-direction: column;
  }
}
@media screen and (max-height: 700px) {
  .page-constraint {
    height: 700px;
  }
}
.hero-items-wrapper--mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .hero-items-wrapper--mobile {
    display: block;
  }
}
.hero-items-wrapper--mobile img {
  position: absolute;
}
.hero-items-wrapper--mobile img.slide-down {
  animation: slide-down 2s ease-in-out 9s 1 normal forwards;
}
.hero-items-wrapper--mobile img.slide-up {
  animation: slide-up 2s ease-in-out 9s 1 normal forwards;
}
.hero-items-wrapper--mobile img.hero-image--top-light-blue-circle {
  left: 2%;
  top: 30%;
  width: 10px;
}
.hero-items-wrapper--mobile img.hero-image--red-chatbox {
  left: 5%;
  top: 55%;
  width: 9.4%;
}
.hero-items-wrapper--mobile img.hero-image--green-diagonal-squares {
  left: 10%;
  top: 25%;
  width: 7.5%;
  max-width: 48px;
}
.hero-items-wrapper--mobile img.hero-image--red-square {
  left: 20%;
  top: 45%;
  width: 3.4%;
}
.hero-items-wrapper--mobile img.hero-image--bottom-light-blue-circle {
  left: 22%;
  top: 65%;
  width: 10px;
}
.hero-items-wrapper--mobile img.hero-image--yellow-play-button-mobile {
  left: 25%;
  top: 18%;
  width: 9.6%;
  max-width: 61px;
}
.hero-items-wrapper--mobile img.hero-image--green-square {
  left: 35%;
  top: 50%;
  width: 7.2%;
  max-width: 46px;
}
.hero-items-wrapper--mobile img.hero-image--red-diamond {
  left: 48%;
  top: 50%;
  width: 12px;
}
.hero-items-wrapper--mobile img.hero-image--blue-cross {
  left: 60%;
  top: 22%;
  width: 6%;
}
.hero-items-wrapper--mobile img.hero-image--green-pointer {
  left: 65%;
  top: 48%;
  width: 13%;
  max-width: 86px;
}
.hero-items-wrapper--mobile img.hero-image--blue-circle {
  left: 80%;
  top: 20%;
}
.hero-items-wrapper--mobile img.hero-image--yellow-sphere {
  left: 80%;
  top: 24%;
  width: 14%;
  max-width: 90px;
}
.hero-items-wrapper--mobile img.hero-image--yellow-vertical-rectangle {
  left: 90%;
  top: 50%;
  width: 6.7%;
  max-width: 42px;
}
.hero-items-wrapper--mobile img.hero-image--blue-diamond {
  left: 96%;
  top: 40%;
  max-width: 38px;
}
.hero-items-wrapper--desktop {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  top: 0;
}
@media screen and (max-width: 1000px) {
  .hero-items-wrapper--desktop {
    display: none;
  }
}
@media screen and (min-width: 1201px) {
  .hero-items-wrapper--desktop {
    width: 100%;
    margin: 0;
  }
}
.hero-items-wrapper--desktop img {
  position: absolute;
}
.hero-items-wrapper--desktop img.hero-image--yellow-nested-rectangle {
  left: 4%;
  top: 60%;
  animation: fade-in-yellow-nested-rectangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-yellow-nested-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 4%;
    top: 60%;
    opacity: 1;
  }
  to {
    left: -2%;
    top: 70%;
  }
}
.hero-items-wrapper--desktop img.hero-image--yellow-rectangle {
  left: 15%;
  top: 82%;
  animation: fade-in-yellow-rectangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-yellow-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 15%;
    top: 82%;
    opacity: 1;
  }
  to {
    left: 12%;
    top: 95%;
  }
}
.hero-items-wrapper--desktop img.hero-image--yellow-semi-circle {
  left: 10%;
  top: 8%;
  width: 76px;
  animation: fade-in-yellow-semi-circle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-yellow-semi-circle {
  0% {
    opacity: 1;
  }
  25% {
    left: 10%;
    top: 8%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 5%;
    top: 15%;
  }
}
.hero-items-wrapper--desktop img.hero-image--red-square {
  left: 18%;
  top: 40%;
  width: 22px;
  animation: fade-in-red-square 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-red-square {
  0% {
    opacity: 1;
  }
  25% {
    left: 18%;
    top: 40%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 2%;
    top: 42%;
  }
}
.hero-items-wrapper--desktop img.hero-image--left-red-rectangle {
  left: 20%;
  top: 58%;
  animation: fade-in-left-red-rectangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-left-red-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 20%;
    top: 58%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 13%;
    top: 60%;
  }
}
.hero-items-wrapper--desktop img.hero-image--red-diamond {
  left: 22%;
  top: 40%;
  animation: fade-in-red-diamond 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-red-diamond {
  0% {
    opacity: 1;
  }
  25% {
    left: 22%;
    top: 40%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 17%;
    top: 42%;
  }
}
.hero-items-wrapper--desktop img.hero-image--green-diagonal-squares {
  left: 25%;
  top: 25%;
  animation: fade-in-green-diagonal-squares 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-green-diagonal-squares {
  0% {
    opacity: 1;
  }
  25% {
    left: 25%;
    top: 25%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 17%;
    top: 15%;
  }
}
.hero-items-wrapper--desktop img.hero-image--red-chatbox {
  left: 30%;
  top: 28%;
  width: 60px;
  animation: fade-in-red-chatbox 2s ease-in-out 9s 1 normal forwards;
}
.hero-items-wrapper--desktop img.hero-image--light-blue-circle {
  left: 32%;
  top: 75%;
  animation: fade-in-light-blue-circle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-light-blue-circle {
  0% {
    opacity: 1;
  }
  25% {
    left: 32%;
    top: 75%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 16%;
    top: 80%;
  }
}
.hero-items-wrapper--desktop img.hero-image--yellow-vertical-rectangle {
  left: 35%;
  top: 55%;
  animation: fade-in-yellow-vertical-rectangle 2s ease-in-out 9s 1 normal
    forwards;
}
@keyframes fade-in-yellow-vertical-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 35%;
    top: 55%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 20%;
    top: 60%;
  }
}
.hero-items-wrapper--desktop img.hero-image--green-square {
  left: 38%;
  top: 55%;
  width: 55px;
  animation: fade-in-green-square 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-green-square {
  0% {
    opacity: 1;
  }
  25% {
    left: 38%;
    top: 55%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 28%;
    top: 90%;
  }
}
.hero-items-wrapper--desktop img.hero-image--yellow-pointer {
  left: 40%;
  top: 35%;
  animation: fade-in-yellow-pointer 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-yellow-pointer {
  0% {
    left: 40%;
    top: 35%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 25%;
    top: 23%;
  }
}
.hero-items-wrapper--desktop img.hero-image--light-red-square {
  left: 42%;
  top: 57%;
  animation: fade-in-light-red-square 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-light-red-square {
  0% {
    opacity: 1;
  }
  25% {
    left: 42%;
    top: 57%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 40%;
    top: 72%;
  }
}
.hero-items-wrapper--desktop img.hero-image--light-red-rectangle {
  left: 48%;
  top: 10%;
  width: 30px;
  animation: fade-in-light-red-rectangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-light-red-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 48%;
    top: 10%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 40%;
    top: 8%;
  }
}
.hero-items-wrapper--desktop img.hero-image--green-circle {
  left: 49%;
  top: 60%;
  animation: fade-in-green-circle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-green-circle {
  0% {
    opacity: 1;
  }
  25% {
    left: 49%;
    top: 60%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 45%;
    top: 80%;
  }
}
.hero-items-wrapper--desktop img.hero-image--blue-cross {
  left: 50%;
  top: 70%;
  width: 32px;
  animation: fade-in-blue-cross 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-blue-cross {
  0% {
    opacity: 1;
  }
  25% {
    left: 50%;
    top: 70%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 60%;
    top: 80%;
  }
}
.hero-items-wrapper--desktop img.hero-image--yellow-play-button {
  left: 52%;
  top: 15%;
  animation: fade-in-yellow-play-button 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-yellow-play-button {
  0% {
    opacity: 1;
  }
  50% {
    left: 52%;
    top: 15%;
    opacity: 1;
    transform: rotate(30deg);
  }
  to {
    left: 58%;
    top: 7%;
  }
}
.hero-items-wrapper--desktop img.hero-image--blue-chevron {
  left: 55%;
  top: 38%;
  animation: fade-in-blue-chevron 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-blue-chevron {
  0% {
    opacity: 1;
  }
  25% {
    left: 55%;
    top: 38%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 48.7%;
    top: 34%;
  }
}
.hero-items-wrapper--desktop img.hero-image--green-pointer {
  left: 62%;
  top: 60%;
  width: 80px;
  animation: fade-in-green-pointer 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-green-pointer {
  0% {
    opacity: 1;
  }
  25% {
    left: 62%;
    top: 60%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 75%;
    top: 72%;
  }
}
.hero-items-wrapper--desktop img.hero-image--green-half-oval {
  left: 63%;
  top: 80%;
  width: 30px;
  animation: fade-in-green-half-oval 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-green-half-oval {
  0% {
    opacity: 1;
  }
  25% {
    left: 63%;
    top: 80%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 70%;
    top: 85%;
  }
}
.hero-items-wrapper--desktop img.hero-image--top-blue-circle {
  left: 72%;
  top: 20%;
  animation: fade-in-top-blue-circle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-top-blue-circle {
  0% {
    opacity: 1;
  }
  25% {
    left: 72%;
    top: 20%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 78%;
    top: 12%;
  }
}
.hero-items-wrapper--desktop img.hero-image--green-rectangle {
  width: 70px;
  left: 75%;
  top: 10%;
  animation: fade-in-green-rectangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-green-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 75%;
    top: 10%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 85%;
    top: 5%;
  }
}
.hero-items-wrapper--desktop img.hero-image--bottom-blue-circle {
  left: 75%;
  top: 40%;
  animation: fade-in-bottom-blue-circle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-bottom-blue-circle {
  0% {
    opacity: 1;
  }
  25% {
    left: 75%;
    top: 40%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 85%;
    top: 50%;
  }
}
.hero-items-wrapper--desktop img.hero-image--yellow-sphere {
  left: 76%;
  top: 25%;
  animation: fade-in-yellow-sphere 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-yellow-sphere {
  0% {
    opacity: 1;
  }
  25% {
    left: 76%;
    top: 25%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 83%;
    top: 23%;
  }
}
.hero-items-wrapper--desktop img.hero-image--orange-curve {
  left: 78%;
  top: 75%;
  width: 40px;
  animation: fade-in-orange-curve 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-orange-curve {
  0% {
    opacity: 1;
  }
  25% {
    left: 78%;
    top: 75%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 85%;
    top: 85%;
  }
}
.hero-items-wrapper--desktop img.hero-image--red-hand {
  left: 79%;
  top: 42%;
  animation: fade-in-red-hand 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-red-hand {
  0% {
    opacity: 1;
  }
  25% {
    left: 79%;
    top: 42%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 93%;
    top: 46%;
  }
}
.hero-items-wrapper--desktop img.hero-image--right-red-rectangle {
  left: 66%;
  top: 36%;
  animation: fade-in-right-red-rectangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-right-red-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 66%;
    top: 36%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 90%;
    top: 35%;
  }
}
.hero-items-wrapper--desktop img.hero-image--blue-vertical-rectangle {
  left: 82%;
  top: 55%;
  animation: fade-in-blue-vertical-rectangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-blue-vertical-rectangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 82%;
    top: 55%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 87%;
    top: 61%;
  }
}
.hero-items-wrapper--desktop img.hero-image--red-triangle {
  left: 82%;
  top: 85%;
  width: 60px;
  animation: fade-in-red-triangle 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-red-triangle {
  0% {
    opacity: 1;
  }
  25% {
    left: 82%;
    top: 85%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 95%;
    top: 90%;
  }
}
.hero-items-wrapper--desktop img.hero-image--blue-diamond {
  left: 90%;
  top: 25%;
  animation: fade-in-blue-diamond 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-blue-diamond {
  0% {
    opacity: 1;
  }
  25% {
    left: 90%;
    top: 25%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 105%;
    top: 19%;
  }
}
.hero-items-wrapper--desktop img.hero-image--blue-square {
  left: 92%;
  top: 75%;
  animation: fade-in-blue-square 2s ease-in-out 9s 1 normal forwards;
}
@keyframes fade-in-blue-square {
  0% {
    opacity: 1;
  }
  25% {
    left: 92%;
    top: 75%;
    opacity: 1;
    transform: scale(1);
  }
  to {
    left: 100%;
    top: 78%;
  }
}
.copy {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex: 1;
  flex: 1;
  min-width: 420px;
  margin: 0 auto;
  position: relative;
  top: 30%;
  max-width: 680px;
}
@media screen and (max-width: 750px) {
  .copy {
    top: 25%;
    width: 100%;
    min-width: 0;
    padding: 0 5%;
  }
}
.cta {
  text-align: center;
  width: 30%;
  position: absolute;
  bottom: 0;
  left: 35%;
  color: #1a73e8;
  cursor: pointer;
  background-color: #fff;
  opacity: 1;
  animation: slide-in-cta 1s ease-in-out 1.75s 1 normal forwards;
}
@media screen and (max-width: 1000px) {
  .cta {
    display: none;
  }
}
.cta.cta--mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .cta.cta--mobile {
    display: block;
    width: 40%;
    left: 30%;
    animation: slide-in-cta 1s ease-in-out 1.5s 1 normal forwards;
  }
}
@media screen and (max-width: 750px) {
  .cta.cta--mobile {
    width: 60%;
    left: 20%;
    bottom: 5%;
  }
}
.cta .cta-text {
  padding-bottom: 15px;
  font: 500 16px Google Sans, Arial, sans-serif;
}
@media screen and (max-width: 750px) {
  .cta .cta-text {
    font-size: 12px;
    padding-bottom: 0;
  }
}
@media screen and (max-width: 750px) {
  .cta .cta-icon {
    width: 14px;
  }
}
.title {
  margin-bottom: 42px;
}
@media screen and (max-width: 1000px) {
  .title {
    margin: 0 5% 30px;
  }
}
.title .logo-mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .title .logo-mobile {
    opacity: 1;
    display: block;
    width: 100%;
    animation: slide-in 1s ease-in-out 0.75s 1 normal forwards;
  }
}
.title .logo-base {
  opacity: 1;
  width: 680px;
  animation: slide-in 1s ease-in-out 1.25s 1 normal forwards;
}
@media screen and (max-width: 1000px) {
  .title .logo-base {
    display: none;
  }
}
.title .logo-details {
  width: 656px;
  position: absolute;
  top: 3%;
  left: 1.75%;
  opacity: 1;
  animation: fade-in 1s ease-in-out 1.75s 1 normal forwards;
}
@media screen and (max-width: 1000px) {
  .title .logo-details {
    display: none;
  }
}
.subheader {
  margin-bottom: 33px;
  text-align: center;
  opacity: 1;
  animation: slide-in 1s ease-in-out 1.5s 1 normal forwards;
}
@media screen and (max-width: 1000px) {
  .subheader {
    display: none;
  }
}
.subheader.subheader--mobile {
  display: none;
  opacity: 1;
}
@media screen and (max-width: 1000px) {
  .subheader.subheader--mobile {
    display: block;
    animation: slide-in 1s ease-in-out 1.25s 1 normal forwards;
    margin-bottom: 30px;
  }
  .subheader.subheader--mobile svg {
    height: 39px;
  }
}
@media screen and (max-width: 750px) {
  .subheader.subheader--mobile svg {
    height: 29px;
  }
}
.description {
  line-height: 1.5;
  font: 400 16px Google Sans, Arial, sans-serif;
  text-align: center;
  color: #676c72;
  opacity: 1;
  background-color: #fff;
  width: 80%;
  margin: 0 auto 20px;
  animation: slide-in 1s ease-in-out 1.5s 1 normal forwards;
}
@media screen and (max-width: 1000px) {
  .description {
    display: none;
  }
}
.description.description--mobile {
  width: 100%;
  margin: 0 0 20px;
  display: none;
  opacity: 1;
}
@media screen and (max-width: 1000px) {
  .description.description--mobile {
    display: block;
    font-size: 16px;
    animation: slide-in 1s ease-in-out 1.25s 1 normal forwards;
  }
}
@media screen and (max-width: 750px) {
  .description.description--mobile {
    font-size: 14px;
  }
}
@keyframes fade-in-red-chatbox {
  0% {
    opacity: 1;
    transform: scale(0.7);
  }
  12% {
    opacity: 1;
  }
  25% {
    left: 30%;
    top: 28%;
    opacity: 1;
    transform: scale(1);
  }
  75% {
    left: 10%;
    top: 30%;
  }
  to {
    left: 10%;
    top: 30%;
  }
}
@keyframes slide-in {
  0% {
    opacity: 1;
    transform: translateY(30%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in-cta {
  0% {
    opacity: 1;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fade-in {
  0% {
    opacity: 1;
  }
  to {
    opacity: 1;
  }
}
@keyframes slide-down {
  0% {
    transform: translateY(0);
  }
  to {
    transform: translateY(150px);
  }
}
@keyframes slide-up {
  0% {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100px);
  }
}
@keyframes slide-up-tablet {
  0% {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10vh);
  }
}
</style>
